import React, { useState } from "react";
import * as RB from "react-bootstrap";
import { toast } from "react-toastify"; // Import toast from react-toastify

function DocumentInfo({ formData, setFormData }) {
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const [isValidImage, setisValidImage] = useState(false);

  const handleImageChange = (e) => {
    const file = e?.target?.files[0];
    // Validate file types (jpg, jpeg, png)
    if (!file) {
      return;
    }
    const isValidFileType =
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png";
    if (!isValidFileType) {
      // Handle invalid file type
      return;
    }
    setFormData({ ...formData, adharImage: file });
  };

  const handleDeleteImage = (index) => {
    setFormData({
      ...formData,
      adharImage: "",
    });
  };

  const handleDragOver = (e, type) => {
    e.preventDefault();
    if (type == "image") {
      setIsDraggingOver(true);
    }
  };

  const handleDragEnter = (e, type) => {
    e.preventDefault();
    if (type == "image") {
      setIsDraggingOver(true);
    }
  };

  const handleDragLeave = (e, type) => {
    e.preventDefault();
    if (type == "image") {
      setIsDraggingOver(false);
    }
  };

  const handleDrop = (e, type) => {
    e.preventDefault();
    if (type == "image") {
      setIsDraggingOver(false);

      const file = e.dataTransfer.files[0];
      if (!file) {
        return;
      }
      const isValidFileType =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png";

      if (!isValidFileType) {
        setisValidImage(true);
        toast.error(
          "Invalid file type. Please upload JPEG, JPG, or PNG images.",
          {
            position: "top-right",
            autoClose: 5000,
          }
        );
        return;
      } else {
        setisValidImage(false);
        setFormData({ ...formData, adharImage: file });
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;

    // if (name === "mobileNo") {
    //   validatedValue = value.replace(/\D/g, "");
    //   setEmergencyContactError(validatedValue.length !== 10);
    // } else if (name === "pinCode") {
    //   validatedValue = value.replace(/\D/g, ""); // Remove non-numeric characters
    // }

    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  return (
    <>
      <h6 className="mt-2">Document Information</h6>
      <hr className="hr-lg mt-1" />
      <RB.Row>
        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Aadhar Card No"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                type="text"
                placeholder="Enter Aadhar Card No"
                name="aadharCardNo"
                value={formData.aadharCardNo}
                onChange={handleInputChange}
                // required
                maxLength={12}
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>

        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Pan Card No"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                type="text"
                placeholder="Enter Pan Card"
                name="panNo"
                value={formData.panNo}
                onChange={handleInputChange}
                // required
                // maxLength={10}
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>
      </RB.Row>
      <RB.Row>
        <RB.Col md={6}>
          <RB.Card>
            <RB.CardBody className="p-2">
              <h6 className="mb-1">Aadhar Card Image</h6>
              <hr />
              <div
                className={`border p-4 text-center d-flex flex-column align-items-center ${
                  isDraggingOver ? "bg-info" : ""
                }`}
                onDragOver={(e) => handleDragOver(e, "image")}
                onDragEnter={(e) => handleDragEnter(e, "image")}
                onDragLeave={(e) => handleDragLeave(e, "image")}
                onDrop={(e) => handleDrop(e, "image")}
              >
                <div className="avatar avatar-circle avatar-lg bg-light text-dark">
                  <i className="material-icons-outlined">cloud_upload</i>
                </div>
                <p className="mb-0">Drag & Drop your image here</p>
                <small className="mb-2">or</small>
                <div>
                  <input
                    type="file"
                    accept="image/jpeg, image/jpg, image/png"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                    id="fileInput"
                  />
                  <RB.Button
                    variant="primary"
                    className="me-2"
                    onClick={() => document.getElementById("fileInput").click()}
                  >
                    <i className="las la-file-upload me-1"></i>Browse Image
                  </RB.Button>
                </div>
              </div>
              <span className={`${isValidImage ? "text-danger" : ""}`}>
                <small>*Note: Only JPG,JPEG and PNG Files are allowed</small>
              </span>

              <RB.Row className="mt-3 g-3">
                {formData.adharImage ? (
                  <RB.Col className="col-md-6 col-lg-4">
                    <div className="position-relative mb-4">
                      <div className="product-image-upload">
                        {formData.adharImage instanceof File ? (
                          <img
                            src={URL.createObjectURL(formData.adharImage)}
                            alt={`Image`}
                          />
                        ) : (
                          // Use formData.adharImage directly when it's already a URL
                          <img src={formData.adharImage} alt={`Image`} />
                        )}
                      </div>
                      <RB.Button
                        variant="danger"
                        className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                        onClick={() => handleDeleteImage(0)} // Assuming index 0 for single image
                      >
                        <i className="material-icons-outlined">delete</i>
                      </RB.Button>
                    </div>
                  </RB.Col>
                ) : null}
              </RB.Row>
            </RB.CardBody>
          </RB.Card>
        </RB.Col>
      </RB.Row>
    </>
  );
}

export default DocumentInfo;
